import React from 'react';
import { QlikUIContext, Reports, QlikWrapper } from 'globaleris-qlik-component';
import 'globaleris-qlik-component/dist/index.css';
import Page from '../../components/page/page';
import PageHeader from '../../components/page/pageHeader';
import { useTranslation } from 'react-i18next';
import { useQlikContext } from '../../hooks/useQlikContext';

export const ReportsPage = () => {
  const [t] = useTranslation(['globalerisLibrary', 'qlik']);
  const { isContextInitialized, context } = useQlikContext();

  return (
    <Page>
      <PageHeader title={`${t('qlik:reportTitle')}`}></PageHeader>
      {isContextInitialized &&
        <QlikUIContext.Provider value={context}>
          {<QlikWrapper component={<Reports />} />}
        </QlikUIContext.Provider>
      }
    </Page>
  );
};
